import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function PainPoints() {
  return <section className="w-full bg-[#111111] py-12 md:py-16 px-4 border-t border-gray-800" data-id="element-229">
      <div className="max-w-2xl mx-auto" data-id="element-230">
        <h2 className="text-2xl md:text-3xl font-black font-heading text-white text-center mb-10 leading-tight" data-id="element-231">
          ⚠️ SI ESTÁS VIVIENDO ESTO… TE VA A SONAR FAMILIAR:
        </h2>

        <div className="space-y-3 mb-8" data-id="element-232">
          <div className="bg-gray-900 rounded-xl p-4 md:p-5 flex items-start gap-3 border border-red-900/30 shadow-lg" data-id="element-233">
            <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-234">❌</span>
            <p className="text-gray-300 font-body text-sm md:text-base leading-snug" data-id="element-235">
              No sabes si intervenir o respetar
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 md:p-5 flex items-start gap-3 border border-red-900/30 shadow-lg" data-id="element-236">
            <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-237">❌</span>
            <p className="text-gray-300 font-body text-sm md:text-base leading-snug" data-id="element-238">
              Evitas conversaciones importantes porque no sabes cómo abordarlas
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 md:p-5 flex items-start gap-3 border border-red-900/30 shadow-lg" data-id="element-239">
            <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-240">❌</span>
            <p className="text-gray-300 font-body text-sm md:text-base leading-snug" data-id="element-241">
              Sientes que todo recae en ti
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 md:p-5 flex items-start gap-3 border border-red-900/30 shadow-lg" data-id="element-242">
            <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-243">❌</span>
            <p className="text-gray-300 font-body text-sm md:text-base leading-snug" data-id="element-244">
              Hay tensión con tus hermanos o falta de organización
            </p>
          </div>
          <div className="bg-gray-900 rounded-xl p-4 md:p-5 flex items-start gap-3 border border-red-900/30 shadow-lg" data-id="element-245">
            <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-246">❌</span>
            <p className="text-gray-300 font-body text-sm md:text-base leading-snug" data-id="element-247">
              Te preocupa lo que viene, pero no sabes cómo prepararte
            </p>
          </div>
        </div>

        {/* Subtle separator */}
        <div className="w-24 h-1 bg-gray-800/60 mx-auto mb-8 rounded-full" data-id="element-248"></div>

        <div className="text-center mb-10" data-id="element-249">
          <p className="text-lg md:text-xl font-black font-heading text-red-400 mb-4 tracking-wide" data-id="element-250">
            ⏳ ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR ASÍ?
          </p>
          <p className="text-gray-400 font-body text-base md:text-lg mb-8 leading-relaxed max-w-lg mx-auto" data-id="element-251">
            Da igual si estás en España, México, Argentina, Colombia o cualquier
            país…
          </p>

          <div className="bg-gray-900/80 p-6 md:p-8 rounded-2xl border border-gray-800 shadow-xl max-w-md mx-auto space-y-4" data-id="element-252">
            <p className="text-lg md:text-xl font-bold text-white font-heading flex items-center justify-center gap-3" data-id="element-253">
              <span className="text-xl" data-id="element-254">👉</span> El problema es el mismo
            </p>
            <p className="text-lg md:text-xl font-bold text-yellow-400 font-heading flex items-center justify-center gap-3" data-id="element-255">
              <span className="text-xl" data-id="element-256">👉</span> Y la solución también
            </p>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-257">
          <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-xl px-8 py-4 rounded-xl shadow-[0_0_20px_rgba(250,204,21,0.2)] transition-all duration-300 cursor-pointer font-heading text-[16px]" data-id="element-258">
            👉 QUIERO LA SOLUCIÓN AHORA
          </button>
        </div>
      </div>
    </section>;
}